import type { FC } from 'react';
import React from 'react';
import { useTranslation } from '@edreamsodigeo/frontend-core';

import type { BaggageConditionTextProps } from './types';

export const baggageConditionToKey = {
  CHECKIN_INCLUDED: 'flightSummary.segment.baggage.checkInBaggage',
  CABIN_INCLUDED: 'flightSummary.segment.baggage.handBaggage',
  BASED_ON_AIRLINE: 'flightSummary.segment.baggage.smallBaggage',
};

export const BaggageConditionText: FC<BaggageConditionTextProps> = ({
  baggageCondition,
  hasCabinBag,
}) => {
  const { t } = useTranslation();
  const key = hasCabinBag
    ? 'cabinbags.option.cabin_bag.included'
    : baggageConditionToKey[baggageCondition];
  return <>{t(key)}</>;
};
